module.exports = __webpack_public_path__ + "images/xibao_top_backview_2026-2027.1790221230673.jpg";